(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["button-fill-script"] && !Shopify.designMode) return;
  try {
    (() => {
    const pointerQuery = window.matchMedia('(pointer: fine)');

    const getFillTransition = (fill) => {
      if (!fill) {
        return 'transform 1s cubic-bezier(0.22, 1, 0.36, 1)';
      }

      const computedStyle = window.getComputedStyle(fill);
      const duration = computedStyle.getPropertyValue('--btn-fill-duration').trim() || '1s';
      const easing = computedStyle.getPropertyValue('--btn-fill-easing').trim() || 'cubic-bezier(0.22, 1, 0.36, 1)';

      return `transform ${duration} ${easing}`;
    };

    const enter = (fill) => {
      if (!pointerQuery.matches || !fill) return;

      fill.style.transition = 'none';
      fill.style.setProperty('--motion-translateY', '110%');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          fill.style.transition = getFillTransition(fill);
          fill.style.setProperty('--motion-translateY', '0%');
        });
      });
    };

    const leave = (fill) => {
      if (!pointerQuery.matches || !fill) return;

      fill.style.transition = getFillTransition(fill);
      fill.style.setProperty('--motion-translateY', '-110%');
    };

    const initButton = (button) => {
      if (!(button instanceof HTMLElement)) return;
      if (button.dataset.buttonFillInit === 'true') return;

      const fill = button.querySelector('.btn-fill');
      if (!fill) return;

      button.dataset.buttonFillInit = 'true';
      fill.style.setProperty('--motion-translateY', '110%');

      button.addEventListener('mouseenter', () => enter(fill));
      button.addEventListener('mouseleave', () => leave(fill));
    };

    const initWithin = (root) => {
      if (!root) return;

      if (root instanceof Element && root.matches('[data-button-fill]')) {
        initButton(root);
      }

      if (root.querySelectorAll) {
        root.querySelectorAll('[data-button-fill]').forEach(initButton);
      }
    };

    initWithin(document);

    if (window.__buttonFillObserverInit === true) return;
    window.__buttonFillObserverInit = true;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          initWithin(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["carousel-scrollbar"] && !Shopify.designMode) return;
  try {
    class CarouselScrollbar extends HTMLElement {
    connectedCallback() {
      this.scroller = this.previousElementSibling?.querySelector('slideshow-slides');
      this.thumb = this.querySelector('.carousel-scrollbar__thumb');

      if (!this.scroller || !this.thumb) return;

      this.update = this.update.bind(this);
      this.scroller.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.scroller);
      this.update();
    }

    disconnectedCallback() {
      this.scroller?.removeEventListener('scroll', this.update);
      this.resizeObserver?.disconnect();
    }

    update() {
      const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
      const canScroll = maxScroll > 1;
      this.hidden = !canScroll;

      if (!canScroll) return;

      const thumbWidth = Math.min(50, this.clientWidth);
      const progress = this.scroller.scrollLeft / maxScroll;
      const travel = this.clientWidth - thumbWidth;

      this.thumb.style.width = `${thumbWidth}px`;
      this.thumb.style.transform = `translateX(${progress * travel}px)`;
    }
  }

  if (!customElements.get('carousel-scrollbar')) {
    customElements.define('carousel-scrollbar', CarouselScrollbar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-bubble"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__cartBubbleUpdateInit) return;
    window.__cartBubbleUpdateInit = true;

    const renderCartBubble = (bubble, itemCount) => {
      const count = bubble.querySelector('[ref="cartBubbleCount"]');
      if (!count) return;

      const limit = Number(bubble.dataset.cartBubbleLimit || 0);
      const shouldShowCount = limit === 0 || itemCount < limit;

      count.textContent = shouldShowCount ? String(itemCount) : '';
      count.classList.toggle('hidden', itemCount === 0);
      bubble.classList.toggle('visually-hidden', itemCount === 0);
      bubble.toggleAttribute('data-maintain-ratio', itemCount <= 99);
    };

    document.addEventListener('cart:update', (event) => {
      const itemCount = Number(event.detail?.data?.itemCount ?? 0);

      document.querySelectorAll('[data-cart-bubble]').forEach((bubble) => {
        renderCartBubble(bubble, itemCount);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-share-buttons"] && !Shopify.designMode) return;
  try {
    if (!window.productShareButtonsInitialized) {
    window.productShareButtonsInitialized = true;

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-instagram-share-button]');

      if (!(button instanceof HTMLButtonElement)) return;

      const shareUrl = button.dataset.shareUrl;
      const shareTitle = button.dataset.shareTitle;
      const isDesktopViewport = window.matchMedia('(min-width: 750px)').matches;

      if (!shareUrl) return;

      try {
        if (!isDesktopViewport && navigator.share) {
          await navigator.share({
            title: shareTitle,
            text: shareTitle,
            url: shareUrl,
          });
          return;
        }

        window.open('https://www.instagram.com/', '_blank', 'noopener,noreferrer');
      } catch (error) {
        if (error?.name === 'AbortError') return;
        console.error(error);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    (() => {
    const vimeoPosterCache = new Map();

    const bindVimeoPosterImages = (root = document) => {
      const posters = root.querySelectorAll('img[data-vimeo-poster][data-vimeo-oembed-url]');

      posters.forEach(async (poster) => {
        if (!(poster instanceof HTMLImageElement)) return;
        if (poster.hasAttribute('data-vimeo-poster-bound')) return;

        const oembedUrl = poster.dataset.vimeoOembedUrl;
        if (!oembedUrl) return;

        poster.setAttribute('data-vimeo-poster-bound', 'true');

        try {
          let thumbnailUrlPromise = vimeoPosterCache.get(oembedUrl);

          if (!thumbnailUrlPromise) {
            thumbnailUrlPromise = fetch(oembedUrl)
              .then((response) => {
                if (!response.ok) throw new Error('Unable to load Vimeo thumbnail');

                return response.json();
              })
              .then((data) => data.thumbnail_url);
            vimeoPosterCache.set(oembedUrl, thumbnailUrlPromise);
          }

          const thumbnailUrl = await thumbnailUrlPromise;
          if (thumbnailUrl) poster.src = thumbnailUrl;
        } catch {
          poster.removeAttribute('data-vimeo-poster-bound');
        }
      });
    };

    const bindAutoplayPosterTransition = (root = document) => {
      const autoplayMedia = root.querySelectorAll('deferred-media[data-autoplay-with-poster]');

      autoplayMedia.forEach((media) => {
        if (media.hasAttribute('data-autoplay-poster-bound')) return;

        const posterButton = media.querySelector('.deferred-media__poster-button');
        if (!(posterButton instanceof HTMLElement)) return;

        const onReady = () => {
          posterButton.classList.add('deferred-media__playing');
          media.setAttribute('data-media-loaded', 'true');
        };

        const video = media.querySelector('video');
        if (video instanceof HTMLVideoElement) {
          if (video.readyState >= 2) {
            onReady();
          } else {
            video.addEventListener('loadeddata', onReady, { once: true });
            video.addEventListener('canplay', onReady, { once: true });
          }
        } else {
          const iframe = media.querySelector('iframe');
          if (iframe instanceof HTMLIFrameElement) {
            iframe.addEventListener('load', onReady, { once: true });
          }
        }

        media.setAttribute('data-autoplay-poster-bound', 'true');
      });
    };

    bindVimeoPosterImages();
    bindAutoplayPosterTransition();
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target instanceof Element || event.target instanceof Document ? event.target : document;
      bindVimeoPosterImages(root);
      bindAutoplayPosterTransition(root);
    });
    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target instanceof Element || event.target instanceof Document ? event.target : document;
      bindVimeoPosterImages(root);
      bindAutoplayPosterTransition(root);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
